
<template>
  <a-layout-content class="wemail-sites-overview">
    <a-breadcrumb :style="{ marginBottom: '20px' }">
      <a-breadcrumb-item>
        <router-link tag="a" :to="{ name: 'sites.overview', params: { siteId: this.$route.params.siteId } }">Site</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>Campaigns</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="wemail-tabs-wrap">
      <SitesNavigation/>
      <div class="wemail-overview-content">
        <CampaignsTable/>
      </div>
    </div>
  </a-layout-content>
</template>
<script>
import SitesNavigation from "@/components/SitesNavigation.vue";
import CampaignsTable from "@/components/CampaignsTable.vue";
export default {
  components: {
    SitesNavigation,
    CampaignsTable
  }
};
</script>